/**
 * @generated SignedSource<<a73853e9ce98fbfbc3b689070bf3ebfa>>
 * @relayHash 3ea067cac2b27e0d77f6fbf0e607bd0d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID acc8836e202e0c7e09d56db86be075d25b2f0c65340770af51deef00abf6b81f

import type { ConcreteRequest, Query } from 'relay-runtime';
export type srcSidebarSelectorQuery$variables = {
  cloudId: string;
};
export type srcSidebarSelectorQuery$data = {
  readonly jira: {
    readonly navigationUIState: {
      readonly isLeftSidebarCollapsed: boolean;
      readonly leftSidebarWidth: number;
    };
  };
};
export type srcSidebarSelectorQuery = {
  response: srcSidebarSelectorQuery$data;
  variables: srcSidebarSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "isLeftSidebarCollapsed"
},
v3 = {
  "kind": "ScalarField",
  "name": "leftSidebarWidth"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "srcSidebarSelectorQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v1/*: any*/),
                "concreteType": "JiraNavigationUIStateUserProperty",
                "kind": "LinkedField",
                "name": "navigationUIState",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": (v2/*: any*/),
                    "action": "THROW",
                    "path": "jira.navigationUIState.isLeftSidebarCollapsed"
                  },
                  {
                    "kind": "RequiredField",
                    "field": (v3/*: any*/),
                    "action": "THROW",
                    "path": "jira.navigationUIState.leftSidebarWidth"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.navigationUIState"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "srcSidebarSelectorQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraNavigationUIStateUserProperty",
            "kind": "LinkedField",
            "name": "navigationUIState",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "acc8836e202e0c7e09d56db86be075d25b2f0c65340770af51deef00abf6b81f",
    "metadata": {},
    "name": "srcSidebarSelectorQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0c300d5f69893a112305132d7426061f";

export default node;
